import { useState } from 'react';

// material-ui
import IconButton from '@mui/material/IconButton';
import Snackbar from '@mui/material/Snackbar';
import Box from '@mui/material/Box';

// assets
import ContentCopyIcon from '@mui/icons-material/ContentCopy';

import { smartCopy } from 'utils-ts/copy';

const CopyToClipboardWithMUI = ({ textToCopy = '', htmlToCopy = '', sx, size, iconButtonSx, showSnackbar = true }) => {
  const [copied, setCopied] = useState(false);

  const handleCopyClick = async () => {
    const success = await smartCopy(textToCopy || htmlToCopy);
    if (success) {
      setCopied(true);
    }
  };

  const handleCloseSnackbar = () => {
    setCopied(false);
  };

  return (
    <Box sx={sx}>
      {textToCopy && (
        <IconButton onClick={handleCopyClick} size={size} sx={iconButtonSx}>
          <ContentCopyIcon fontSize="inherit" />
        </IconButton>
      )}
      <Snackbar
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
        open={copied && showSnackbar}
        autoHideDuration={3000}
        onClose={handleCloseSnackbar}
        message="Copied to clipboard!"
      />
    </Box>
  );
};

export default CopyToClipboardWithMUI;
